import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Customer } from '@inyova/models';

@Component({
    selector: 'app-strategy-stock-split-slider',
    styleUrls: ['./strategy-stock-split-slider.component.scss'],
    templateUrl: './strategy-stock-split-slider.component.html',
    standalone: false
})
export class StrategyStockSplitSliderComponent implements OnChanges {
  @Input() bondRatio: number;
  @Input() customer: Customer;
  @Input() insufficient: string;
  @Input() maxSliderValue: number;
  @Input() minSliderValue: number;
  @Input() pickedValue: string;
  @Input() recommendedClass: string;
  @Input() riskName: number;
  @Input() stockRatio: number;
  @Output() update = new EventEmitter<{ target: HTMLInputElement }>();
  @Input() recheck = false;
  initialStock = 0;
  initialBond = 0;
  initialRiskName = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.bondRatio &&
      !changes.bondRatio.previousValue &&
      changes.stockRatio &&
      !changes.stockRatio.previousValue &&
      changes.riskName &&
      !changes.riskName.previousValue
    ) {
      this.initialBond = Math.ceil(changes.bondRatio.currentValue as number);
      this.initialStock = Math.ceil(changes.stockRatio.currentValue as number);
      this.initialRiskName = changes.riskName.currentValue;
    }
  }

  updateValue(event: { target: HTMLInputElement }): void {
    this.update.emit(event);
  }
}
